function formatDate(date) {
  var fecha = new Date(date);
  var options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return fecha.toLocaleDateString("es-ES", options);
  // const day = date.getDate();
  // let month = date.getMonth();
  // const year = date.getFullYear();
  // switch (month) {
  //   case 0:
  //     month = "ENERO";
  //     break;
  //   case 1:
  //     month = "FEBRERO";
  //     break;
  //   case 2:
  //     month = "MARZO";
  //     break;
  //   case 3:
  //     month = "ABRIL";
  //     break;
  //   case 4:
  //     month = "MAYO";
  //     break;
  //   case 5:
  //     month = "JUNIO";
  //     break;
  //   case 6:
  //     month = "JULIO";
  //     break;
  //   case 7:
  //     month = "AGOSTO";
  //     break;
  //   case 8:
  //     month = "SEPTIEMBRE";
  //     break;
  //   case 9:
  //     month = "OCTUBRE";
  //     break;
  //   case 10:
  //     month = "NOVIEMBRE";
  //     break;
  //   case 11:
  //     month = "DICIEMBRE";
  // }
  // return `${day} DE ${month} DE ${year}`;
}
module.exports = formatDate;
